import { isEmpty } from "lodash";
import { LABSTORE_ACCESS, ROLES } from "./constants";

const isAuthorized = (authRoles, currentRoles) => {
    return currentRoles?.some((role) => authRoles?.includes(role));
};

const isLabstoreAuthorized = (currentUser, action) => {
    const storeAccess = currentUser?.organization?.storeSettings?.access;

    if (isEmpty(storeAccess) && currentUser?.role !== ROLES.superAdmin)
        return false;
    else if (!action && !isEmpty(storeAccess)) return true;

    switch (action) {
        case LABSTORE_ACCESS.view:
            return storeAccess?.includes(LABSTORE_ACCESS.view);

        case LABSTORE_ACCESS.subscribe:
            return storeAccess?.includes(LABSTORE_ACCESS.subscribe);

        case LABSTORE_ACCESS.publish:
            return storeAccess?.includes(LABSTORE_ACCESS.publish);
        default:
            return false;
    }
};

export { isAuthorized, isLabstoreAuthorized };
